export enum SPECS {
  BUY_NOW_BUTTON_ENABLED = 'specs.stores.BuyNowViewer',
  ENABLE_LOST_BUSINESS_EMAIL = 'specs.stores.EnableLostBusinessEmail',
}
